<template>
  <el-table-column class-name="menu">
    <template slot-scope="scope">
      <el-dropdown @command="handleContent">
        <span class="el-dropdown-link">
          <el-button slot="reference" class="operateIcon" @click.stop>
            <i class="el-icon-more"></i>
          </el-button>
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="handleCopy(scope.row)">コピー登録</el-dropdown-item>
            <el-dropdown-item :command="handleDelete(scope.row)" :disabled="!deletable(scope.row, scope.$index)">削除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </el-table-column>
</template>

<script>
export default {
  props: {
    cbdelete: Function,
    deletable: {
      type: Function,
      default: () => true
    }
  },
  methods: {
    handleContent (command) {
      // コピー登録
      if (command.command === 'copy') {
        this.$emit('copy', command.data)
      }
      // 削除
      if (command.command === 'delete') {
        this.cbdelete(command.data)
      }
    },
    handleCopy (row) {
      return {
        command: 'copy',
        data: row
      }
    },
    handleDelete (row) {
      return {
        command: 'delete',
        data: row
      }
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.menu {
      width: 6.5em;
    }
  }
}
</style>
